import { Presentator } from '@docentecas/app/store/presentators/presentators.model';

export class AddPresentator {
  static readonly type = '[Presentators] Add a new Presentator';
  constructor(public action: Presentator) {}
}
